import { ApplicationState } from '@api/store';
import { useSelector } from 'react-redux';

export const useMobile = (): boolean => {
    const browser = useSelector(({ browser }: ApplicationState) => browser);
    return browser?.lessThan?.hd;
};
